/* eslint-disable */
import cx from 'classnames';
import qs from 'qs';
import rison from 'rison';
import moment from 'moment-timezone';
import { connect } from 'react-redux'
import React, { Component } from 'react';
import { Helmet } from "react-helmet";
import { Link } from 'react-router';
import { Button, Form, Glyphicon, FormGroup, ControlLabel, FormControl, Table, Modal, Checkbox, Radio } from 'react-bootstrap';
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from 'react-places-autocomplete'
import { NotificationManager } from 'react-notifications';
import FontAwesome from 'react-fontawesome';
import { compose, withProps, withState, withHandlers, lifecycle  } from "recompose";
import { withGoogleMap, withScriptjs, GoogleMap, Marker, InfoWindow } from 'react-google-maps'
import { Elements, StripeProvider, CardElement, injectStripe } from 'react-stripe-elements';

import 'react-dates/initialize';
import { DateRangePicker, SingleDatePicker, DayPickerRangeController } from 'react-dates';
import 'react-dates/lib/css/_datepicker.css';

import OzComponent from '../lib/OzComponent';
import { usd, newOrder, isLoggedIn, ss, navTo, mapDispatch, distance, upperFirst, setToken, prettyDate, getParams, urlEncodeQueryFilters, urlDecodeQueryFilters } from '../utils/util';
import './Main.css';
import './partials/TimeSlotsTable2.css';
import Wrapper from './Wrapper';
import LocationForm from './partials/LocationForm';
import {
  register,
  login,
  fetchUser,
  getGeoIp,
  listLocations,
  listRooms,
  listTimeSlots,
  createEscape,
  addToRegion,
  setAlreadyEscaped,
  listUsernames,
  listReviews,
  getTimeSlot,
  getRoom,
} from '../actions';
import RegisterForm from './partials/RegisterForm';
import WhereField from './partials/WhereField';
import EscapeAdder from './partials/EscapeAdder';
import QuickEscapeAdder from './partials/QuickEscapeAdder';
import RoomMap from './partials/RoomMap';
import ReviewItem from './partials/ReviewItem';
import OmniField from './partials/OmniField';
import TimeSlotsByDay from './partials/TimeSlotsByDay';
import OzModalButton from './partials/OzModalButton';
import ReportMistake from './partials/ReportMistake';
import Loading from './partials/Loading';
import AddToRegionForm from './partials/AddToRegionForm';
import BookTimeSlot from './partials/BookTimeSlot';
import { PercentBar } from './partials/ReviewItem';

const mobileDelta = 1;
const daysToPull = 1;
const defaultRadius = 25;


const filterSpecs = {
  date: {
    single: true,
    hide: true,
  },
  time: {
    pretty: null,
    single: true,
  },
  room: {
    pretty: null,
  },
  company: {
    pretty: null,
  },
  players: {
    pretty: 'Players',
    single: true,
  },
  done: {
  },
}

function getFilterValues(filters, key) {
  let values = []
  for (let filter of filters) {
    if (filter.key == key) {
      values.push(filter.value);
    }
  }
  return values;
}

function regexRemoveStateZip(str) {
  return str.replace(/, [A-Z]{2} [0-9]{5}/, '');
}


class FilterEditor extends Component {
  constructor(props) {
    super(props);
    let toggleActive = {};
    for (let key of Object.keys(props.filters)) {
      toggleActive[key] = true;
    }
    console.log('filter editor got these props:', props);
    this.state = { toggleActive, optionFilter: {} };
  }

  toggle(key) {
    let toggleActive = Object.assign({}, this.state.toggleActive);
    toggleActive[key] = !toggleActive[key];
    this.setState({ toggleActive })
  }

  toggleActive(key) {
    return this.state.toggleActive[key];
  }

  toggleHideDone(username, pretty) {
    let values = this.getFilter('done');
    if (values.includes(username)) {
      this.removeFilter('done', username);
    } else {
      this.setFilter('done', username, pretty);
    }
  }

  toggleCompany(name) {
    let values = this.getFilter('company');
    if (values.includes(name)) {
      this.removeFilter('company', name);
    } else {
      this.setFilter('company', name);
    }
  }

  toggleRoom(id, name) {
    let values = this.getFilter('room');
    console.log('toggle room', values, id, name);
    if (values.includes(id)) {
      this.removeFilter('room', id);
    } else {
      this.setFilter('room', id, name);
    }
  }

  removeFilter(key, value) {
    console.log('FilterEditor remove filter', key, value);
    this.props.onRemoveFilter(key, value);
  }

  setFilter(key, value, pretty) {
    // console.log('filter editor', key, value);
    this.props.onSetFilter(key, value, pretty);
  }

  getFilter(key) {
    return getFilterValues(this.props.filters, key);
  }

  getOptionFilter(key) {
    return this.state.optionFilter[key] || '';
  }

  setOptionFilter(key, value) {
    let optionFilter = Object.assign({}, this.state.optionFilter);
    optionFilter[key] = value;
    this.setState({ optionFilter });
  }

  renderFilterableOptions(key, optionsGroups) {
    let f = this.getOptionFilter(key);

    let nodes = optionsGroups.map(optionsGroup => {
      let count = 0;
      let optionNodes = optionsGroup[1].map(option => {
        console.log('F??', f);
        if (f && option[1].toUpperCase().indexOf(f.toUpperCase()) == -1) {
          return null;
        }
        count++;

        let values = this.getFilter(key);
        let active = values.includes(option[0]);
        return (
          <div
            key={option[0]}
            className={cx('done-choice', { active })}
            onClick={() => this.toggleHideDone(option[0], option[1])}
          >
            {option[1]}
          </div>
        );
      });

      if (count == 0) return null;

      return (
        <div className="done-choices">
          <div className="group-name">{optionsGroup[0]}</div>
          <div className="group-done-choices">
            {optionNodes}
          </div>
        </div>
      );
    });

    return (
      <div className="done-wrapper">
        {/*<input
          type="text"
          placeholder="Filter..."
          value={this.getOptionFilter(key)}
          onChange={(e) => this.setOptionFilter(key, e.target.value)}
        />*/}
        {nodes}
      </div>
    );
  }

  renderDoneBy() {
    let node;
    let key = 'done';

    if (!this.props.user || !this.props.user.profile) {
      node = <div>Sign in to hide rooms you've already done</div>;
    } else {
      let profile = this.props.user.profile;
      let usernames = this.props.usernames;
      usernames = usernames.sort((a, b) => a.localeCompare(b));

      let optionsGroups = [];

      if (this.props.user && this.props.user.profile) {
        optionsGroups.push([
          'Me', [['username:' + this.props.user.username, "Hide rooms I've done"]]
        ]);
      }


      let teamOptions = profile.teamMemberships.map(tm => ['team_id:' + tm.id, tm.team.name])
      optionsGroups.push([
        'My teams',
        teamOptions
      ]);

      let teamUsernamesDict = {};
      let teamMemberships = profile.teamMemberships || [];
      for (let tm of teamMemberships) {
        for (let member of tm.team.members) {
          teamUsernamesDict[member.username] = true;
        }
      }
      let teamUsernames = Object.keys(teamUsernamesDict).sort((a, b) => a.localeCompare(b));
      let usernameOptions = teamUsernames.map(username => ['username:' + username, username]);
      optionsGroups.push([
        'My team members',
        usernameOptions
      ]);

      console.log('optionsGroups', optionsGroups);
      node = this.renderFilterableOptions(key, optionsGroups);
    }


    return (
      <div className={cx('filter', 'can-toggle', { active: this.toggleActive(key) })}>
        <div onClick={() => this.toggle(key)} className="filter-name">
          <div className="toggle-arrow"><FontAwesome name="chevron-circle-right" /></div> Hide Rooms Already Done
        </div>
        <div className="filter-value">
          {node}
        </div>
      </div>
    );
  }

  renderNumPlayers() {
    let options = [['', 'Select number of players']];
    for (let i = 1; i <= 20; i++) {
      options.push([i, i]);
    }

    let key = 'players';
    return (
      <div className={cx('filter', 'can-toggle', { active: this.toggleActive(key) })}>
        <div onClick={() => this.toggle(key)} className="filter-name">
          <div className="toggle-arrow"><FontAwesome name="chevron-circle-right" /></div> Number of players
        </div>
        <div className="filter-value">
          <FormControl
            componentClass="select"
            value={this.getFilter('players')[0]}
            onChange={(e) => this.setFilter('players', e.target.value)}
          >
            {options.map(option => <option key={option[0]} value={option[0]}>{option[1]}</option>)}
          </FormControl>
        </div>
      </div>
    );
  }

  renderTime() {
    let key = 'time';

    let options = [
      ['morning', 'Morning (6am-11am)'],
      ['midday', 'Mid-day (11am-4pm)'],
      ['afternoon', 'Afternoon (2pm-6pm)'],
      ['evening', 'Evening (5pm-9pm)'],
      ['late', 'Late (8pm-midnight)'],
    ];

    let nodes = options.map(option => {
      let active = this.getFilter(key)[0] == option[0];
      return (
        <div
          key={option[0]}
          className={cx('time-choice', { active })}
          onClick={() => this.setFilter(key, option[0])}
        >
          {option[1]}
        </div>
      );
    });

    return (
      <div className={cx('filter', 'can-toggle', { active: this.toggleActive(key) })}>
        <div onClick={() => this.toggle(key)} className="filter-name">
          <div className="toggle-arrow"><FontAwesome name="chevron-circle-right" /></div> Time of day
        </div>
        <div className="filter-value">
          <div className="times-wrapper">
            {nodes}
          </div>
        </div>
      </div>
    );
  }

  renderCompanies() {
    console.log('filter editor companies', this.props.companyNames);
    let key = 'company';
    if (!this.props.companyNames) return;

    let nodes = this.props.companyNames.map(name => {
      let values = this.getFilter(key);
      let active = values.includes(name);
      return (
        <div
          key={name}
          className={cx('company-choice', { active })}
          onClick={() => this.toggleCompany(name)}
        >
          {name}
        </div>
      );
    });

    return (
      <div className={cx('filter', 'can-toggle', { active: this.toggleActive(key) })}>
        <div onClick={() => this.toggle(key)} className="filter-name">
          <div className="toggle-arrow"><FontAwesome name="chevron-circle-right" /></div> Company
        </div>
        <div className="filter-value">
          <div className="company-choices">
            {nodes}
          </div>
        </div>
      </div>
    );
  }

  renderRooms() {
    if (!this.props.roomsByCompany) return;
    let companyNames = Object.keys(this.props.roomsByCompany);
    companyNames = companyNames.sort((a, b) => a.localeCompare(b));

    let key = 'room';
    let nodes = companyNames.map(companyName => {
      let rooms = this.props.roomsByCompany[companyName];
      rooms = rooms.sort((a, b) => a.name.localeCompare(b.name));
      // console.log('rooms.map:', rooms);
      let roomNodes = rooms.map(room => {
        let values = this.getFilter(key);
        let active = values.includes(room.id);
        return (
          <div
            key={room.id}
            className={cx('room-choice', { active })}
            onClick={() => this.toggleRoom(room.id, room.name)}
          >
            {room.name}
          </div>
        );
      });
      return (
        <div key={companyName} className="company-rooms">
          <div className="company-name">{companyName}</div>
          <div className="company-rooms">{roomNodes}</div>
        </div>
      );
    });

    return (
      <div className={cx('filter', 'can-toggle', { active: this.toggleActive(key) })}>
        <div onClick={() => this.toggle(key)} className="filter-name">
          <div className="toggle-arrow"><FontAwesome name="chevron-circle-right" /></div> Room
        </div>
        <div className="filter-value">
          <div className="rooms-wrapper">
            {nodes}
          </div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className="FilterEditor">
        <div className="filters">
          {this.renderDoneBy()}
          {this.renderNumPlayers()}
          {/*this.renderTime()*/}
          {this.renderCompanies()}
          {this.renderRooms()}
        </div>
        <div className="close-editor-wrapper">
          <div className="close-editor" onClick={() => this.props.onClose()}>
            Done
          </div>
        </div>
      </div>
    );
  }
}


class SearchNew extends Component {
  state = {};

  setDate(date) {
    this.setState({ focused: false });
    this.props.onChangeDate(date.format('YYYY-MM-DD'));
  }

  setCity(cityName) {
    this.props.onChangeCity(cityName);
  }

  handleOmniResult(result) {
    console.log('new search got an omni result:', result);
    switch (result.type) {
      case 'city':
        this.setCity(result.full);
        break;
    }
  }

  render() {
    return (
      <div className="SearchNew">
        <div className="omni-and-date">
          <OmniField
            q={this.props.prefill}
          />
          <div className="date-picker">
            <SingleDatePicker
              date={this.props.date}
              onDateChange={date => this.setDate(date)}
              focused={this.state.focused}
              onFocusChange={({ focused }) => this.setState({ focused })}
              id="when"
              numberOfMonths={1}
              displayFormat="dddd, M/D"
            />
          </div>
        </div>
      </div>
    );
  }
}


class RoomDetails extends Component {
  render() {
    let room = this.props.room;
    let timeSlot = this.props.timeSlot;

    let detailNodes = [];

    if (room.topInCity) {
      detailNodes.push(
        <div key="top" className="room-detail top-room">
          <FontAwesome name="trophy" /> Top room
        </div>
      );
    }

    if (room.percent) {
      detailNodes.push(
        <div key="percent" className="room-detail">
          <FontAwesome name="star" /> {room.percent}%
        </div>
      );
    }

    if (room.minPeople && room.maxPeople) {
      let body;
      if (room.minPeople == room.maxPeople) {
        body = room.minPeople;
      } else {
        body = room.minPeople + '-' + room.maxPeople;
      }
      detailNodes.push(
        <div key="players" className="room-detail">
          <FontAwesome name="users" /> {body}
        </div>
      );
    } else if (room.maxPeople) {
      detailNodes.push(
        <div key="players" className="room-detail">
          <FontAwesome name="users" /> {room.maxPeople} max
        </div>
      );
    }

    if (room.privacy == 'always' || timeSlot && timeSlot.privacy == 'always') {
      detailNodes.push(
        <div key="privacy" className="room-detail">
          <FontAwesome name="shield" /> private
        </div>
      );
    }

    return <div className="RoomDetails">{detailNodes}</div>;
  }
}


class LocationTimeSlots extends Component {
  render() {
    let timeSlots = this.props.timeSlots;
    let grouped = {}
    for (let timeSlot of timeSlots) {
      let key = timeSlot.tzDate;
      if (!grouped[key]) {
        grouped[key] = [];
      }
      grouped[key].push(timeSlot);
    }

    let keys = Object.keys(grouped);
    keys.sort();

    let nodes = keys.map(key => {
      let timeSlotNodes = grouped[key].map(timeSlot => {
        return (
          <div key={timeSlot.id} className={cx('room-time-slot', timeSlot.status)}>
            <div className="time"><a href={timeSlot.bookUrl}>{timeSlot.prettyHour}</a></div>
            <div className="status">{timeSlot.status}</div>
          </div>
        )
      });
      let pretty = moment(key, 'YYYY-MM-DD').format('dddd, M/D');
      return (
        <div key={key} className="time-slot-group">
          <div className="time-slot-group-date">{pretty}</div>
          <div className="room-time-slots">{timeSlotNodes}</div>
        </div>
      )
    });

    return (
      <div className="LocationTimeSlots">
        {nodes}
      </div>
    )
  }
}


class Location extends Component {
  state = {
    active: {},
    reviews: {},
  };

  toggle(id) {
    let active = Object.assign({}, this.state.active);
    active[id] = !active[id];
    this.setState({ active });

    if (!this.state.reviews[id]) {
      this.props.listReviews({ room: id, limit: 5 }, { silent: true, local: true })
        .then(resp => {
          console.log('list reviews resp:', resp);
          if (resp.error) return;
          let reviews = Object.assign({}, this.state.reviews);
          reviews[id] = resp.items;
          this.setState({ reviews });
        });
    }
  }

  addToRegion(e, values) {
    console.log('add to region', values);
    this.props.addToRegion(values)
      .then(resp => {
        if (resp.error) return;
        NotificationManager.success('Added to region');
        this.setState({ adding: false });
      });
  }

  renderAdminAddToRegion() {
    let user = this.props.user;
    if (!user) return;
    let isStaff = user.isStaff;
    if (!isStaff) return;

    let location = this.props.location;
    console.log('admin render for location:', location);

    let editUrl;
    if (location.companyFk) {
      editUrl = '/manage/' + location.companyFk.id;
    }

    return (
      <div className="admin">
        <OzModalButton
          modalTitle="Add Location to Region"
          show={this.state.adding}
          onShow={() => this.setState({ adding: true })}
          onHide={() => this.setState({ adding: false })}
          >

          <Button><FontAwesome name="plus-square" /> Add Location To Region</Button>

          <AddToRegionForm
            modal={true}
            values={{ locationId: this.props.location.id }}
            errors={this.props.errors.addToRegion}
            onSubmit={(e, values) => this.addToRegion(e, values)}
            onCancel={() => this.setState({ adding: false })}
            buttonText="Add To Region"
            cancelText="Cancel"
            location={this.props.location}
          />
        </OzModalButton>

        {location.companyFk && <Link to={editUrl}><Button><FontAwesome name="edit" /> Edit Listing {location.companyFk.id}</Button></Link>}
      </div>
    )
  }

  render() {
    let rooms = this.props.rooms;
    let location = this.props.location;
    let timeSlotsByRoomId = this.props.timeSlotsByRoomId;
    rooms.sort((a, b) => a.name.localeCompare(b.name));

    let roomNodes = rooms.map(room => {
      let timeSlots = timeSlotsByRoomId[room.id];
      let timeSlotsNode = null;
      // console.log('aab', room);
      if (timeSlots) {
        timeSlotsNode = <LocationTimeSlots timeSlots={timeSlots} />;
      } else if (room.hasFutureTimeSlots) {
        timeSlotsNode = (
          <div key={room.id} className="no-data">
            Try another date, there are no time slots on {this.props.date.format('MMM Do')}
          </div>
        );
        // timeSlotsNode = (
        //   <div key={room.id} className="no-data">
        //     <p>We aren't able to get time slots data for this room yet.</p>
        //     <p>Room owner?{' '}
        //       <a href={'mailto:marcell@escapespy.com?subject=Add time slots for ' + room.name}>Contact us to add time</a>
        //     </p>
        //   </div>
        // )
      } else {
        timeSlotsNode = (
          <div key={room.id} className="no-data">
            No time slot data for this room...
          </div>
        );
      }

      let active = this.state.active[room.id];
      // console.log('show info for:', room);

      let reviewsNode;
      let reviews = this.state.reviews[room.id];
      if (reviews) {
        reviewsNode = reviews.map(review => <ReviewItem noButton review={review} />);
        // console.log('reviews length', reviews.length);
        if (reviews.length == 0) {
          reviewsNode = <div>No reviews yet...</div>;
        }
      } else {
        reviewsNode = <Loading />;
      }

      return (
        <div key={room.id} className={cx('room', { active })}>
          <div className="room-header">
            <div className="room-toggle">
              <FontAwesome name="chevron-circle-right" />
            </div>
            <div className="room-name-wrapper" onClick={() => this.toggle(room.id)}>
              <div className="room-name">{room.name}</div>
              <RoomDetails room={room} />
            </div>
            <div className="controls">
              <QuickEscapeAdder
                room={room}
                user={this.props.user}
                onDone={this.props.onAddedEscape}
              />
            </div>
          </div>

          <div className="room-more-info">
            <hr/>
            <div className="room-time-slots">{timeSlotsNode}</div>
            <hr/>
            <div className="reviews-description">
              <div className="description">
                {room.description}
                {!room.description && 'No description available...'}
              </div>
              <div className="reviews">
                {reviewsNode}
              </div>
            </div>
          </div>
        </div>
      )
    });

    let regionNodes = location.regions.map(region => {
      return (
        <div key={region.slug} className="region">
          <Link to={'/region/' + region.slug}>{region.name}</Link>
        </div>
      );
    });

    return (
      <div className="Location">
        <div className="company-info">
          <div className="company-name">
            {location.company}
            {this.renderAdminAddToRegion()}
          </div>
          <div className="company-address">{location.address}</div>
          <div className="company-regions">{regionNodes}</div>
        </div>
        <div className="rooms">{roomNodes}</div>
      </div>
    );
  }
}


class Room extends Component {
  render() {
    let room = this.props.room;
    let timeSlots = this.props.timeSlots;
    if (!timeSlots) return;

    let infoParts = [];
    if (room.minutes) infoParts.push(room.minutes + ' minutes');
    if (room.minPeople && room.maxPeople) infoParts.push(room.minPeople + '-' + room.maxPeople + ' people');
    if (room.difficulty) infoParts.push(upperFirst(room.difficulty));
    if (room.theme) infoParts.push(upperFirst(room.theme));
    // infoParts.push('id: ' + timeSlot.id);
    let info = '';
    if (infoParts.length) info = infoParts.join(', ');

    return (
      <div className="Room">
        <div className="room-info">
          <div className="room-name">{room.name}</div>
          {room.location && <div className="room-company">{room.location.company}</div>}
          {room.location && <div className="room-address">{room.location.address}</div>}
          <div className="room-info-parts">{info}</div>
          <hr />
          <div className="room-desc">{room.description}</div>
        </div>
        <div className="room-time-slots">
          <TimeSlotsByDay timeSlots={timeSlots} />
        </div>
      </div>
    )
  }
}


class ListRooms extends Component {
  render() {
    if (!this.props.rooms) return null;
    if (!this.props.timeSlots) return null;

    let byRoomId = {};
    let locationHasTimeSlots = {};
    for (let timeSlot of this.props.timeSlots.items) {
      if (!byRoomId[timeSlot.room]) {
        byRoomId[timeSlot.room] = [];
      }
      byRoomId[timeSlot.room].push(timeSlot);
      locationHasTimeSlots[timeSlot.location.id] = true;
    }

    let roomsByLocationId = {};
    for (let room of this.props.rooms.items) {
      if (!room.location) {
        continue;
      }
      if (!roomsByLocationId[room.location.id]) {
        roomsByLocationId[room.location.id] = [];
      }
      roomsByLocationId[room.location.id].push(room);
    }

    // console.log('roomsByLocationId', roomsByLocationId);

    let locationIds = Object.keys(roomsByLocationId);
    locationIds.sort((a, b) => {
      let aLocation = roomsByLocationId[a][0].location;
      let bLocation = roomsByLocationId[b][0].location;
      let aHas = locationHasTimeSlots[aLocation.id];
      let bHas = locationHasTimeSlots[bLocation.id];

      if (aHas && !bHas) return -1;
      if (!aHas && bHas) return 1;

      return aLocation.company.localeCompare(bLocation.company);
    });

    let nodes = locationIds.map(id => {
      return (
        <Location
          key={id}
          location={roomsByLocationId[id][0].location}
          rooms={roomsByLocationId[id]}
          timeSlotsByRoomId={byRoomId}
          date={this.props.date}
          user={this.props.user}
          errors={this.props.errors}
          addToRegion={this.props.addToRegion}
          onAddedEscape={() => this.props.onAddedEscape()}
          listReviews={this.props.listReviews}
        />
      );
    });

    return (
      <div>
        {nodes}
      </div>
    );
  }
}

class Stars extends Component {
  render() {
    let stars = [];
    let starsBg = [];
    let n = this.props.stars;

    for (let i = 0; i < 5; i++) {
      starsBg.push(<span key={i} className="star-wrapper"><FontAwesome name="star" /></span>);
    }

    for (let i = 0; i < 5; i++) {
      if (n >= 1) {
        stars.push(<span key={i} className="star-wrapper"><FontAwesome name="star" /></span>);
      } else if (n >= .5) {
        stars.push(<span key={i} className="star-wrapper"><FontAwesome name="star-half" /></span>);
      } else {
        stars.push(<span key={i} className="star-wrapper"></span>);
      }
      n -= 1;
    }
    return (
      <div className="stars">
        <div className="stars-active">{stars}</div>
        <div className="stars-bg">{starsBg}</div>
      </div>
    );
  }
}


class TimeSlotDetails extends Component {

  state = {};

  constructor(props) {
    super(props);
    this.state.room = props.room;
    this.state.timeSlot = props.timeSlot;
  }

  componentDidMount() {
    let p1 = this.props.getRoom(this.state.room.id, { silent: true, local: true }, { update: 1 })
      .then(resp => {
        this.setState({ room: resp.obj });
      });
    let p2 = this.props.getTimeSlot(this.state.timeSlot.id, { silent: true, local: true }, { update: 1 })
      .then(resp => {
        let loading = this.state.loading - 1;
        this.setState({ timeSlot: resp.obj });
      });
    this.setState({ loading: true });
    Promise.all([p1, p2])
      .then(() => this.setState({ loading: false }));
  }

  renderPrice(timeSlot) {
    switch (timeSlot.pricingStyle) {
      case 'flat':
        if (!timeSlot.priceFlat) {
          return null;
        }
        return (
          <span>
            {timeSlot.priceFlat && usd(timeSlot.priceFlat).replace('.00', '')}
          </span>
        );
      case 'per_person':
        if (!timeSlot.pricePerPerson) {
          return null;
        }
        return (
          <span>
            {usd(timeSlot.pricePerPerson).replace('.00', '')}/person
          </span>
        );

      case 'varied':
        let json = timeSlot.priceVariedJson;
        // console.log('json', json);
        if (!json || json == undefined) {
          return null;
        }
        let priceTable = JSON.parse(json);
        // console.log('price', priceTable);
        let people = '' + (this.props.people || 2);
        let price = priceTable[people];
        if (!price || price == undefined) {
          return null;
        }
        return (
          <span>
            {usd(price.price / people).replace('.00', '')}/person
          </span>
        );

      default:
        return null;
    }
  }

  setAlreadyEscaped() {
    if (this.props.user && this.props.user.profile) {
      this.setState({ flow: 'askEscaped' });
    } else {
      this.setState({ flow: 'askSignUp' });
    }
  }

  onAddedEscape() {
    this.props.onAddedEscape();
  }

  renderDebug() {
    let room = this.state.room;
    let timeSlot = this.state.timeSlot;
    
    return (
      <div className="debug">
        <div className="ids">[{timeSlot.id}/{room.id}] last updated {moment().to(timeSlot.timeUpdated)}</div>
        <div>{this.state.loading && <Loading size="small" inline />}</div>
      </div>
    );
  }

  startBook() {
    this.props.onStartBook();
  }

  render() {
    let room = this.state.room;
    let timeSlot = this.state.timeSlot;
    if (!timeSlot || !room) return null;

    // TODO: Add distance back in
    // let dist = Math.round(distance(
    //   room.location.lat, room.location.lng,
    //   this.props.lat, this.props.lng));

    let prettyStart = timeSlot.prettyHour;
    let m = moment(timeSlot.datetime);
    let prettyDate_ = m.format('dddd, M/D');
    // let prettyDate_ = prettyDate(timeSlot.datetime);
    let price = this.renderPrice(timeSlot);

    let infoParts = [];
    if (room.minutes) infoParts.push(room.minutes + ' minutes');
    if (room.minPeople && room.maxPeople) infoParts.push(room.minPeople + '-' + room.maxPeople + ' people');
    if (room.difficulty) infoParts.push(upperFirst(room.difficulty));
    if (room.theme) infoParts.push(upperFirst(room.theme));
    // infoParts.push('id: ' + timeSlot.id);
    let info = '';
    if (infoParts.length) info = infoParts.join(', ');

    let buttons = null;

    let user = this.props.user;
    let haveProfile = user && user.profile;
    let didIt = false;
    if (haveProfile) {
      for (let escape of user.profile.escapes) {
        if (escape.room.id == room.id) {
          didIt = escape;
        }
      }
    }

    let reviewNode = null;
    if (room.percent) {
      reviewNode = (
        <div>
          <hr />
          <Link to={'/r/' + room.slug + '/' + room.id}>
            <PercentBar percent={room.percent} slim gray />
            <div>Read reviews</div>
          </Link>
        </div>
      )
    }

    return (
      <div className={cx('time-slot-popup', timeSlot.status)}>
        <div className="time-slot-room-name">
          <div className="time-slot-popup-title">{upperFirst(room.name)}</div>
          <QuickEscapeAdder
            room={room}
            user={this.props.user}
            onDone={() => this.onAddedEscape()}
          />
        </div>
        <div className="time-slot-status-time">
          <div className="time-slot-time">{prettyStart}, {prettyDate_}</div>
          <div className={cx('time-slot-status', timeSlot.status)}>{timeSlot.status}</div>
        </div>
        <div>{price && <span>{price}, </span>}</div>
        {info && <div>{info}</div>}
        <div>{regexRemoveStateZip(room.location.address)}</div>
        {reviewNode}
        <hr />
        <div className="time-slot-description">{!this.state.flow && room.description}</div>

        <br/>

        {didIt && <div className="did-it">
         <Link to={'/p/' + user.username}>
         {didIt.didEscape && <div>You ESCAPED from this room!</div>}
         {!didIt.didEscape && <div>You DID NOT escape from this room...</div>}
         <b>Check it out on your profile.</b></Link>
         </div>}

         <div className="instant-book">
           {timeSlot.canBook && <Button onClick={() => this.startBook()}>Book On EscapeSpy</Button>}
         </div>

         <div className="time-slot-buttons">
           <div className="more-info">
             <Link to={'/r/' + room.slug + '/' + room.id}><Button>More Info</Button></Link>
           </div>

           <div className="book-now">
             <a href={timeSlot.bookUrl} target="_blank">
               <Button>Book Now</Button>
             </a>
           </div>
         </div>

        {this.renderDebug()}
      </div>
    );
  }
}

TimeSlotDetails = connect(
  (state) => { return {
    user: state.user,
    errors: state.errors,
  }},
  (dispatch) => {
    return mapDispatch(dispatch, {
      fetchUser,
      createEscape,
      setAlreadyEscaped,
      register,
      login,
      getRoom,
      getTimeSlot,
    });
  },
)(TimeSlotDetails);


class DetailsModal extends Component {

  state = {
    workflow: 'view',
  }

  setAlreadyEscaped(roomId) {
    this.props.setAlreadyEscaped(roomId, true);
    this.props.onHide()
  }

  startBook(id) {
    this.setState({ workflow: 'book' })
  }

  render() {
    let room = this.props.room;
    let timeSlot = this.props.timeSlot;

    if (!room || !timeSlot) {
      return null;
    }

    return (
      <div
        className={cx('details-modal', { active: this.props.show })}
        style={{left: this.props.x, top: this.props.y}}
      >
        <div className="details-modal-header">
          <div className="close-modal" onClick={() => this.props.onHide()}>
            <FontAwesome name="times-circle" />
          </div>
          {room.location.company}
        </div>
        <div className="details-modal-body">
          {this.state.workflow == 'view' && <TimeSlotDetails
            key={timeSlot.id}
            room={room}
            timeSlot={timeSlot}
            lat={this.props.lat}
            lng={this.props.lng}
            people={this.props.people}
            onStartBook={() => this.startBook(timeSlot.id)}
            onAddedEscape={() => {
                           this.props.onAddedEscape();
                           this.props.onHide();
                          }}
           />}
          {this.state.workflow == 'book' && <Elements><BookTimeSlot timeSlotId={timeSlot.id} /></Elements>}
        </div>
      </div>
    );
  }
}


class AlreadyEscaped extends Component {

  render() {
    if (!this.props.user || !this.props.user.profile) {
      return null;
    }

    let escapes = this.props.user.profile.escapes;
    if (escapes.length == 0) {
      return null;
    }

    return (
      <div className="already-escaped">
        <div>Not showing {escapes.length} room{escapes.length == 1 ? '' : 's'} you already escaped from</div>
      </div>
    );
  }
}


class HoursForRoom extends Component {
  render() {
    let timeSlots = this.props.timeSlots;
    let room = this.props.room;

    timeSlots.sort((a, b) => a.datetime.localeCompare(b.datetime));

    let nodes = timeSlots.map(timeSlot => {
      let slotsLeftNode = null;
      if (timeSlot.slotsLeft && room.maxPeople) {
        let suffix;
        if (timeSlot.slotsLeft <= room.maxPeople) {
          suffix = '/' + room.maxPeople;
        }
        slotsLeftNode = (
          <div className="slots-left">({timeSlot.slotsLeft}{room.suffix} left)</div>
        );
      } else if (timeSlot.partiallyBooked) {
        slotsLeftNode = (
          <div className="slots-left">(partially booked)</div>
        );
      }

      return (
        <div key={timeSlot.id} className={cx('room-time-slot', timeSlot.status)}>
          {timeSlot.prettyHour} {slotsLeftNode}
        </div>
      );
    });

    let locationNode;
    if (room.location) {
      locationNode = (
        <div className="room-location-info">
          <div className="room-location-company">{room.location.company}</div>
          <div className="room-location-city">{room.location.city.name}</div>
        </div>
      );
    }

    let ref = 'timeSlot' + room.id;
    let timeSlot = timeSlots[0];
    let status = timeSlot.status;

    return (
      <div
        ref="ref"
        className={cx('HoursForRoom', status)}
        onClick={(e) => this.props.onPick(e, room, timeSlot, this.refs.ref)}
      >
        <div className="room-time-slots">{nodes}</div>
        <div className="room-info">
          <div className="room-details"><RoomDetails room={room} timeSlot={timeSlot} /></div>
          <div className="room-name">{room.name}</div>
          {locationNode}
        </div>
      </div>
    );
  }
}
          // <div className="room-company">{timeSlot.location.company}</div>
          // <div className="room-city">{timeSlot.location.city.name}</div>


class HourForLocation extends Component {
  render() {
    let timeSlots = this.props.timeSlots;
    let location = this.props.location;

    let timeSlotsByRoom = {};
    for (let timeSlot of timeSlots) {
      let id = timeSlot.room;
      if (!timeSlotsByRoom[id]) {
        timeSlotsByRoom[id] = [];
      }
      timeSlotsByRoom[id].push(timeSlot);
    }

    let keys = Object.keys(timeSlotsByRoom);
    keys.sort((a, b) => timeSlotsByRoom[a][0].datetime.localeCompare(timeSlotsByRoom[b][0].datetime))

    let nodes = [];
    for (let key of keys) {
      let room = this.props.roomsById[key];
      let timeSlots = timeSlotsByRoom[room.id];
      nodes.push(<HoursForRoom
                   key={room.id}
                   timeSlots={timeSlots}
                   room={room}
                   onPick={this.props.onPick}
                 />);
    }

    return (
      <div className="HourForLocation">
        <div className="location-info">
          <div className="location-company">{location.company}</div>
          <div className="location-city">{location.city.name}</div>
        </div>

        <div className="location-rooms">{nodes}</div>
      </div>
    );
  }
}


class Hour extends Component {

  state = {
    style: 'hour',
  }

  render() {
    let body;
    if (this.state.style == 'company') {
      body = this.renderCompanyStyle();
    } else {
      body = this.renderHourStyle();
    }

    console.log('debug xyz hour has body?', this.props.hour, body);

    if (!body) return null;

    let dateStr = moment(this.props.date, 'YYYY-MM-DD').format('ddd M/D');

    return (
      <div className="Hour">
        <div className="pretty-hour">
          {this.props.hour}
          <span className="date">{dateStr}</span>
        </div>
        <div className="hour-locations">{body}</div>
      </div>
    );
  }

  renderCompanyStyle() {
    let timeSlots = this.props.timeSlots;
    // console.log('HOUR time slots', timeSlots);
    let timeSlotsByLocation = {};
    for (let timeSlot of timeSlots) {
      let id = timeSlot.location.id;
      if (!timeSlotsByLocation[id]) {
        timeSlotsByLocation[id] = [];
      }
      timeSlotsByLocation[id].push(timeSlot);
    }

    // console.log('HOUR timeSlotsByLocation', timeSlotsByLocation);

    let keys = Object.keys(timeSlotsByLocation);
    keys.sort((a, b) => {
      let aVal = timeSlotsByLocation[a][0].datetime;
      let bVal = timeSlotsByLocation[b][0].datetime;
      return aVal.localeCompare(bVal);
    });

    timeSlots.sort((a, b) => a.datetime.localeCompare(b.datetime));
    let seen = {};
    let nodes = timeSlots.map(timeSlot => {
      let room = this.props.roomsById[timeSlot.room];
      if (!room) return <div key={timeSlot.id}></div>;

      let key = room.name + ':' + timeSlot.prettyHour + ':' + timeSlot.status;
      if (seen[key]) return null;
      seen[key] = true;

      let ref = 'timeSlot' + timeSlot.id;

      let user = this.props.user;
      let haveProfile = user && user.profile;
      let didIt = false;
      if (haveProfile) {
        for (let escape of user.profile.escapes) {
          if (escape.room.id == room.id || escape.room.name == room.name) {
            didIt = escape;
          }
        }
      }

      return (
        <HoursForRoom
          key={room.id}
          timeSlots={[timeSlot]}
          room={room}
          onPick={this.props.onPick}
        />
      );
    });

    nodes = [];
    for (let key of keys) {
      let timeSlots = timeSlotsByLocation[key];
      let location = timeSlotsByLocation[key][0].location;
      nodes.push(<HourForLocation
                   key={location.id}
                   timeSlots={timeSlots}
                   location={location}
                   roomsById={this.props.roomsById}
                   onPick={this.props.onPick}
                 />);
    }

    return <div className="companies">{nodes}</div>;
  }

  renderHourStyle() {
    let timeSlots = this.props.timeSlots;

    console.log('debug xyz render HOUR STYLE', timeSlots);

    // Recently updated first, so when we de-dupe they'll show up
    timeSlots.sort((a, b) => {
      return b.timeUpdated.localeCompare(a.timeUpdated);
    });

    let seen = {};
    timeSlots.sort((a, b) => a.datetime.localeCompare(b.datetime));
    let nodes = [];
    for (let timeSlot of timeSlots) {
    // let nodes = timeSlots.map(timeSlot => {
      let room = this.props.roomsById[timeSlot.room];
      console.log('debug xyz FOUND ROOM?', room);
      if (!room) continue ;// <div key={timeSlot.id}></div>;

      let key = room.name + ':' + timeSlot.prettyHour + ':' + timeSlot.status;
      if (seen[key]) {
        console.log('debug xyz seen', key);
        continue;
      }
      seen[key] = true;

      let node = (
        <HoursForRoom
          key={room.id}
          timeSlots={[timeSlot]}
          room={room}
          onPick={this.props.onPick}
        />
      );
      nodes.push(node);
    }

    console.log('debug xyz nodes length:', nodes.length);

    if (nodes.length == 0) return;

    return <div className="hours">{nodes}</div>;
  }
}


class TimeSlotsTable2 extends Component {

  state = {};

  timeSlotsByHour() {
    // console.log('by hour', this.props.timeSlots);
    let byHour = {};
    for (let timeSlot of this.props.timeSlots.items) {
      if (!timeSlot.prettyHour) {
        console.log('missing prettyHour, skip', timeSlot);
        continue;
      }
      let m = timeSlot.prettyHour.match(/(\d+):(\d+)(am|pm)/);
      let hour = m[1] + m[3];
      if (!byHour[hour]) {
        byHour[hour] = [];
      }
      byHour[hour].push(timeSlot);
    }
    return byHour;
  }

  handlePick(e, room, timeSlot, el) {
    // console.log('PICK', e);
    // console.log('PICK left', el.offsetLeft);
    // console.log('PICK top', el.offsetTop);
    this.setState({
      activeRoom: room,
      activeTimeSlot: timeSlot,
      x: el.offsetLeft,
      y: el.offsetTop,
    })
  }

  render() {
    if (!this.props.timeSlots) return null;
    if (!this.props.roomsById) return null;

    let byHour = this.timeSlotsByHour();
    let hours = Object.keys(byHour).sort((a, b) => {
      return byHour[a][0].datetime.localeCompare(byHour[b][0].datetime);
    });

    console.log('debug xyz HOURS:', hours, byHour);

    let nodes = hours.map(hour => {
      return (
        <Hour
          user={this.props.user}
          key={hour}
          onPick={(e, r, ts, el) => this.handlePick(e, r, ts, el)}
          hour={hour}
          date={this.props.date}
          roomsById={this.props.roomsById}
          timeSlots={byHour[hour]} />
      )
    });

    // console.log('debug xyz nodes', nodes);

    return (
      <div>
        <DetailsModal
          show={!!this.state.activeRoom}
          room={this.state.activeRoom}
          x={this.state.x}
          y={this.state.y}
          timeSlot={this.state.activeTimeSlot}
          lat={this.props.lat}
          lng={this.props.lng}
          people={this.props.people}
          onHide={() => this.setState({ activeRoom: null, activeTimeSlot: null })}
          setAlreadyEscaped={this.props.setAlreadyEscaped}
          onAddedEscape={this.props.onAddedEscape}
        />
        {nodes}
        {nodes.length == 0 && <div className="no-time-slots">
         <div className="big-msg">No times on <b>{this.props.date.format('MMM Do')}</b></div>
          Try changing the date or narrowing your filters.
        </div>}
      </div>
    );
  }
}

class Main extends OzComponent {

  static need = [
    ['user', fetchUser],
    ['usernames', listUsernames],
    // ['locations', listLocations],
    // ['rooms', listRooms],
  ]

  constructor(props) {
    super(props);

    let params = getParams();
    console.log('rison params are:', params);

    let prefill = null;
    let radius = defaultRadius;
    let show = 'list';
    let filters = [];
    let date;
    if (params) {
      if (params.city) {
        prefill = params.city;
      }
      if (params.show) {
        show = params.show;
      }
      filters = this.filtersFromUrlParams(params);
    }

    let hasDateFilter = false;
    for (let filter of filters) {
      if (filter.key == 'date') {
        hasDateFilter = true;
      }
    }
    if (!hasDateFilter) {
      filters.push({ key: 'date', value: moment().format('YYYY-MM-DD') });
    }

    this.state = {
      filters,
      show: show,
      query: params,
      status: 'either',
      hideDone: '',
      radius: radius,
      city: prefill,
      loading: true,
      prefill,
    };
  }

  componentDidMount() {
    if (this.state.query && this.state.query.city) {
      this.find();

      // TODO: Once I fix Google maps quotas, return to pulling
      // geocoded address

      // geocodeByAddress(this.state.query.city)
      //   .then(results => getLatLng(results[0]))
      //   .then(latLng => {
      //     let where = {
      //       name: this.state.query.city,
      //       lat: latLng.lat,
      //       lng: latLng.lng,
      //     };
      //     this.setState(where);
      //   });
    } else {
      this.props.getGeoIp().then(resp => this.find());
    }
  }

  filtersFromUrlParams(params) {
    if (params.filters) {
      console.log('rison parse:', params.filters);
      return urlDecodeQueryFilters(params.filters);
      // // return JSON.parse(params.filters);
      // try {
      //   return rison.decode_array(params.filters);
      // } catch (e) {
      //   return [];
      // }
    } else {
      return [];
    }
  }

  encodedUrlParamsFromFilters() {
    // return JSON.stringify(this.state.filters);
    console.log('rison encode', this.state.filters);
    // let encoded = rison.encode_array(this.state.filters);
    // console.log('use rison', encoded);
    // return encoded;
    return urlEncodeQueryFilters(this.state.filters);
  }

  updateCurrentUrl(params, silent=false) {
    // params.filters = this.urlParamsFromFilters();

    let allowed = ['city', 'show', 'filters'];

    let urlParams = {};
    for (let key of allowed) {
      if (params[key] != undefined) {
        urlParams[key] = params[key];
      }
    }

    for (let key of Object.keys(urlParams)) {
      if (!urlParams[key]) {
        delete urlParams[key];
      }
    }

    if (params.radius != defaultRadius) urlParams.radius = params.radius;
    console.log('rison urlParams', urlParams);
    let search = qs.stringify(urlParams);
    console.log('rison search', search);
    search += '&filters=' + this.encodedUrlParamsFromFilters();
    // console.log('update url', params, search);
    navTo(window.location.pathname + '?' + search, !silent);
  }

  handleAddedEscape() {
    console.log('handleAddedEscape running');
    this.find(null, true);
  }

  find(e, silent=false) {
    if (e) {
      e.preventDefault();
    }
    let useDaysToPull;
    if (['map', 'rooms'].includes(this.state.show)) {
      useDaysToPull = 3;
    } else {
      useDaysToPull = daysToPull;
    }
    let params = {
      date: this.getDate().format('YYYY-MM-DD'),
      days: useDaysToPull,
      radius: this.state.radius,
      hideUgc: 1,
    };

    console.log('setHideDone state', this.state.hideDone, this.state);
    if (this.state.hideDone) params.hideDone = 1;

    // Order:
    // (1) lat/lng
    // (2) params.city
    // (3) geo IP lat/lng
    let geoIp = this.props.geoIp || {};
    let query = this.state.query;
    if (this.state.lat && this.state.lng) {
      params.lat = this.state.lat;
      params.lng = this.state.lng;
    } else if (query && query.city) {
      params.city = query.city;
    } else {
      params.lat = geoIp.lat;
      params.lng = geoIp.lng;
    }
    if (this.state.city) {
      params.city = this.state.city;
    }

    let locationParams;

    if (this.state.show == 'map' && this.state.bounds) {
      locationParams = {
        city: params.city,
        nelat: this.state.bounds.northEast.lat,
        nelng: this.state.bounds.northEast.lng,
        swlat: this.state.bounds.southWest.lat,
        swlng: this.state.bounds.southWest.lng,
        hideUgc: 1,
        // hideNoTimeSlots: 1,
      };
    } else {
      locationParams = {
        city: params.city,
        lat: params.lat,
        lng: params.lng,
        radius: params.radius,
        hideUgc: 1,
        // hideNoTimeSlots: 1,
      };
    }

    let locationsNoFiltersParams = Object.assign({}, locationParams);
    locationParams.filters = JSON.stringify(this.state.filters);

    this.updateCurrentUrl(Object.assign(params, { show: this.state.show }), silent);

    let roomParams = Object.assign({}, locationParams);
    // for (let f of [['room__name', 'name'], ['company', 'location__company']]) {
    //   if (params[f[0]]) {
    //     roomParams[f[1]] = params[f[0]];
    //   }
    // }

    let updateFn = (resp) => {
      let rooms = {}
      let companies = {};
      console.log('locations', resp);
      let roomsByCompany = {};
      for (let location of resp.items) {
        companies[location.company] = true;
        for (let room of location.rooms) {
          rooms[room.id] = room.name;
          if (!roomsByCompany[location.company]) {
            roomsByCompany[location.company] = [];
          }
          roomsByCompany[location.company].push(room);
        }
      }

      console.log('roomsByCompany', roomsByCompany);

      let companiesArr = Object.keys(companies);
      companiesArr.sort((a, b) => a.localeCompare(b));
      // let companyOptions = companiesArr.map(c => [c, c]);
      // companyOptions.unshift(['all', 'All']);
      // console.log('companies', companyOptions);

      console.log('companiesArr', companiesArr);

      let delta = {
        companies: companiesArr,
        roomsByCompany: roomsByCompany,
      };
      let needsRefresh = false;
      if (this.state.room) {
        let found = false;
        for (let company of Object.keys(roomsByCompany)) {
          for (let room of roomsByCompany[company]) {
            if (room.name == this.state.room) {
              found = true;
            }
          }
        }
        if (!found) {
          needsRefresh = true;
          delta.room = 'all';
        }
      }

      if (this.state.company) {
        let found = false;
        for (let c of companiesArr) {
          if (c == this.state.company) {
            found = true;
          }
        }
        if (!found) {
          needsRefresh = true;
          delta.company = 'all';
        }
      }

      console.log('delta', delta);

      this.setState(delta, () => {
        if (needsRefresh) {
          // TODO!!
          // this.find();
        }
      });
    };

    console.log('filter sending params', params);
    console.log('filter sending location params', locationParams);

    let timeSlotParams = Object.assign({}, params);
    timeSlotParams.filters = JSON.stringify(this.state.filters);

    let promises = [
      this.props.listRooms(roomParams, { background: true, silent: true }),
      this.props.listTimeSlots(timeSlotParams, { background: true, silent: true }),
      this.props.listLocations(locationParams, { background: true, silent: true }),
      this.props.listLocations(locationsNoFiltersParams, { background: true, silent: true, local: true }).then(updateFn),
    ];

    if (!silent) {
      this.setState({ loading: true });
      Promise.all(promises)
        .then(() => this.setState({ loading: false }));
    }
  }

  // location(id) {
  //   let locations = this.props.locations ? this.props.locations.items : [];
  //   for (let location of locations) {
  //     if (location.id == id) {
  //       return location;
  //     }
  //   }
  //   return {};
  // }

  // room(id) {
  //   let rooms = this.props.rooms ? this.props.rooms.items : [];
  //   for (let room of rooms) {
  //     if (room.id == id) {
  //       return room;
  //     }
  //   }
  //   return {};
  // }

  setFilter(key, value, pretty, refresh) {
    console.log('set the filter!', key, value);

    let spec = filterSpecs[key];
    let filters = [];
    let didEdit = false;
    for (let filter of this.state.filters) {
      if (spec.single && filter.key == key) {
        filter = Object.assign({}, filter, { value });
        if (pretty) {
          filter = Object.assign({}, filter, { pretty });
        }
        didEdit = true;
      }
      filters.push(filter);
    }
    if (!didEdit) {
      let filter = { key, value };
      if (pretty) {
        filter.pretty = pretty;
      }
      filters.push(filter);
    }

    console.log('setting filters to:', filters);
    this.setState({ filters }, () => {
      let params = Object.assign({}, getParams());
      this.updateCurrentUrl(params);
      if (refresh) {
        setTimeout(() => this.find(), 5);
      }
    });
  }

  removeFilter(key, value, refresh) {
    console.log('remove the filter!', key, value, refresh);
    let filters = [];
    for (let filter of this.state.filters) {
      let match = filter.key == key;
      if (value != null) {
        match = match && filter.value == value;
      }
      if (!match) {
        filters.push(filter);
      }
    }
    this.setState({ filters }, () => {
      let params = Object.assign({}, getParams());
      this.updateCurrentUrl(params);
      if (refresh) {
        setTimeout(() => this.find(), 5);
      }
    });
  }

  setCity(cityName) {
    this.setState({
      city: cityName,
      lat: null,
      lng: null,
    }, () => {
      setTimeout(() => this.find(), 5);
    });
  }

  setWhere(where, shouldFind=false) {
    console.log('set where', where);
    this.setState({
      city: where.name,
      lat: where.lat,
      lng: where.lng,
    }, () => {
      // if (shouldFind)
      if (shouldFind) setTimeout(() => this.find(), 5);
      // if (shouldFind) setTimeout(() => this.find(), 5);
    })
  }

  setFromMap(center, bounds) {
    console.log('SET FROM MAP', center, bounds);

    this.setState({
      city: '',
      lat: center.lat,
      lng: center.lng,
      bounds: bounds,
    }, () => {
      setTimeout(() => this.find(null, true), 5);
    })

    // setWhere({ name: '',a lat, lng }, true);
  }

  getDate() {
    let values = getFilterValues(this.state.filters, 'date');
    return moment(values[0], 'YYYY-MM-DD');
  }

  setDateDelta(delta) {
    let date = this.getDate();
    date = date.add(delta, 'days');
    this.setStartDate(date.format('YYYY-MM-DD'))
  }

  setStartDate(date) {
    this.setFilter('date', date, null, true);
  }

  setAlreadyEscaped(roomId, value) {
    this.props.setAlreadyEscaped(roomId, value)
      .then(() => this.find());
  }

  setShow(show) {
    let delta = { show };
    if (show != 'map') {
      delta.bounds = null;
    }
    let params = Object.assign({}, getParams(), { show });
    this.updateCurrentUrl(params);
    this.setState(delta, () => this.find())
  }

  renderSwitcher() {
    let options = [
      ['list', 'Times'],
      ['rooms', 'Rooms'],
      // ['map', 'Map'],
    ];

    let nodes = options.map(option => {
      return (
        <div
          key={option[0]}
          className={cx('option', { active: this.state.show == option[0] })}
          onClick={() => this.setShow(option[0])}
        >
          {option[1]}
        </div>
      )
    });

    let date = this.getDate();
    let prevDate = this.getDate().add(-1, 'days');
    let nextDate = this.getDate().add(1, 'days');

    return (
      <div className="switcher">
        <div className="date-arrow prev" onClick={() => this.setDateDelta(-1)}>
          <div className="date-arrow-inner">
            <div className="arrow"><FontAwesome name="chevron-circle-left" /></div>
            <div className="date">
              <div>{prevDate.format('ddd')}</div>
              <div>{prevDate.format('M/D')}</div>
            </div>
          </div>
        </div>
        <div className="options">
          {nodes}
        </div>
        <div className="date-arrow next" onClick={() => this.setDateDelta(1)}>
          <div className="date-arrow-inner">
            <div className="date">
              <div>{nextDate.format('ddd')}</div>
              <div>{nextDate.format('M/D')}</div>
            </div>
            <div className="arrow"><FontAwesome name="chevron-circle-right" /></div>
          </div>
        </div>
      </div>
    );
  }

  renderLoading() {
    return (
      <div className="main-loading">
        <Loading />
      </div>
    )
  }

  renderSearchNew() {
    console.log('new????', this.props.usernames);
    let usernames = this.props.usernames ? this.props.usernames.items.map(u => u.username) : [];
    return <SearchNew
             date={this.getDate()}
             prefill={this.state.prefill}
             onChangeDate={(date) => this.setStartDate(date)}
             onChangeCity={(cityName) => this.setCity(cityName)}
             onSetFilter={(key, value, pretty, refresh) => this.setFilter(key, value, pretty, refresh)}
             onRemoveFilter={(key, value, refresh) => this.removeFilter(key, value, refresh)}
             refresh={() => this.find()}

             companyNames={this.state.companies}
             roomsByCompany={this.state.roomsByCompany}
             usernames={usernames}
             user={this.props.user}

             filters={this.state.filters}
           />;
  }

  showAddFilter() {
    this.setState({ filtering: true });
  }

  hideAddFilter() {
    this.setState({ filtering: false });
    this.find();
  }

  render() {
    let geoIp = this.props.geoIp || {};
    let location = this.state.where ? this.state.where.name : geoIp.city + ', ' + geoIp.regionCode;

    let companies = this.state.companies || [];
    let roomsById = {};
    let rooms = this.props.rooms ? this.props.rooms.items : [];
    for (let room of rooms) {
      roomsById[room.id] = room;
    }
    let usernames = this.props.usernames ? this.props.usernames.items.map(u => u.username) : [];

    let filterNodes = this.state.filters.map(filter => {
      let key = filter.key;
      let spec = filterSpecs[key];
      if (spec.hide) return null;
      let value = filter.pretty || filter.value;

      let name = spec.pretty;
      let fn = () => this.removeFilter(key, filter.value, true);
      return (
        <div className="display-filter" key={key + '.' + value}>
          <div className="filter-text">
            {name && <span>{name}: </span>}{value}
          </div>
          <div className="filter-circle">
            <FontAwesome name="times-circle" onClick={fn} />
          </div>
        </div>
      );
    });

    // console.log('debug xyz time slots', this.props.timeSlots);

    return (
      <Wrapper className="Main">
        {this.state.filtering && <FilterEditor
         onSetFilter={(key, value, pretty, refresh) => this.setFilter(key, value, pretty, refresh)}
         onRemoveFilter={(key, value, refresh) => this.removeFilter(key, value, refresh)}
         onClose={() => this.hideAddFilter()}

         filters={this.state.filters}
         companyNames={this.state.companies}
         usernames={usernames}
         roomsByCompany={this.state.roomsByCompany}
         user={this.props.user}
         />}

        <div className="top-part">
          <div className="top-blurb">Find <b>escape rooms</b> near you</div>
          {this.renderSearchNew()}
        </div>

        <div className="mistake-and-switcher">
          {this.renderSwitcher()}
          {/*<ReportMistake />*/}
        </div>

        <div className={cx('add-filter-wrapper', this.state.show)}>
          <div className="add-filter-inner">
            <div className="add-filter" onClick={() => this.showAddFilter()}>
              <FontAwesome name="plus-circle" /> Add Filter
            </div>
            <div className={cx('display-filters', this.state.show)}>
              {filterNodes}
            </div>
          </div>
        </div>

        {this.state.loading && this.renderLoading()}

        {this.state.show == 'map' && <RoomMap
         lat={this.state.lat || geoIp.lat}
         lng={this.state.lng || geoIp.lng}
         onUpdate={(center, bounds) => this.setFromMap(center, bounds)}
         {...this.props}
         />}

        {(!this.state.loading && this.state.show == 'rooms') && <ListRooms
         date={this.getDate()}
         onAddedEscape={() => { this.handleAddedEscape(); }}
         {...this.props}
         />}

        {(!this.state.loading && this.state.show == 'list') && <TimeSlotsTable2
         setAlreadyEscaped={(id, v) => this.setAlreadyEscaped(id, v)}
         onAddedEscape={() => { this.handleAddedEscape(); }}
         roomsById={roomsById}
         timeSlots={this.props.timeSlots}
         date={this.getDate()}
         lat={this.state.lat || geoIp.lat}
         lng={this.state.lng || geoIp.lng}
         people={this.state.people}
         user={this.props.user}
         />}
      </Wrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    geoIp: state.get.geoIp,
    locations: state.list.location,
    rooms: state.list.room,
    timeSlots: state.list.timeSlot,
    errors: state.errors,
    usernames: state.list.username,
  };
}

function mapDispatchToProps(dispatch) {
  return mapDispatch(dispatch, {
    fetchUser,
    register,
    login,
    listTimeSlots,
    getGeoIp,
    listLocations,
    listRooms,
    addToRegion,
    listReviews,
  });
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Main);



/** WEBPACK FOOTER **
 ** ./src/components/Main.js
 **/